<div class="record-group">
  <h2 class="text-center">{{ label }}</h2>
  <div id="syndetics_unbound"></div>
</div>
